<template>

  <div class="app">
    <div class="topnav">
      <div class="content">
        <span class="ShiningChange" />
        <span class="Bright" />
        <span class="MagicalBright" />
        <span class="Change" />
        <div class="mbcom">
          <router-link v-for="(item, index) in mbcom" :key="index" exact :to="item.url" @click.native="mbconbtn(index)">{{ item.name }}</router-link>
        </div>
        <div class="sccom">
          <router-link v-for="(item, index) in sccom" :key="index" exact :to="item.url" @click.native="sccombtn(index)">{{ item.name }}</router-link>
        </div>
        <a href="https://els.ztgame.com/index.shtml" class="logo" />
      </div>

    </div>
    <transition :name="transitionName">
      <keep-alive>
        <router-view class="router-view" />
      </keep-alive>
    </transition>
    <a href="javascript:;" class="arrow left" @click="back()" />
    <a href="javascript:;" class="arrow right" @click="go()" />
  </div>
</template>
<script>
import Mztapi, { $$ } from './tools/utils';
// import Particle from './components/Particle';

let runWx = null; // 微信分享组件
let wxtitle = '大哥带你玩，送3亿福利';
let wxdesc = '史玉柱的宝库开启，人人免费挖，海量道具免费得！';
let wximages = '';
let count = 0;
let index = 0;
import '@babel/polyfill';
export default {
  data() {
    return {
      mbcom: [
        {
          url: 'elsword',
          name: '艾索德'
        }, {
          url: 'rena',
          name: '蕾娜'
        }, {
          url: 'chung',
          name: '澄'
        }, {
          url: 'ara',
          name: '艾拉'
        }, {
          url: 'elesis',
          name: '艾丽希斯'
        }, {
          url: 'ain',
          name: '艾因'
        }, {
          url: 'laby',
          name: '娜薇'
        }
      ],
      sccom: [
        {
          url: 'aisha',
          name: '爱莎'
        }, {
          url: 'raven',
          name: '雷文'
        }, {
          url: 'eve',
          name: '伊芙'
        }, {
          url: 'add',
          name: '艾迪'
        }, {
          url: 'lu',
          name: '露'
        }, {
          url: 'ciel',
          name: '希尔'
        }, {
          url: 'rose',
          name: '萝丝'
        }

      ],
      transitionName: ''

    }
  },
  watch: {
    '$route'(to, from) {
      // console.log(to, from)
      // const toDepth = to.path.split('/').length
      // const fromDepth = from.path.split('/').length
      // this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left'
    }
  },
  beforeCreate() {
    // this.$router.push({ path: '/' });
  },
  mounted() {
    const _this = this;
    let sprt = {};
    sprt.imgs = [
      require('./images/bg.jpg'),
      require('./images/leiwen_02.png'),
      require('./images/ShiningChange.png'),
      require('./images/MagicalBright.png'),
      require('./images/logo.png'),
      require('./images/aisuode.png'),
      require('./images/luosi_02.png'),
      require('./images/leina.jpg'),
      require('./images/leina.png'),
      require('./images/leina_02.png'),
      require('./images/topnav1.png'),
      require('./images/topnav2.png'),

      require('./images/mb.png'),
      require('./images/sc.png'),
      require('./images/arrow.png'),
      require('./images/wenben1.png'),
      require('./images/wenben2.png'),
      require('./images/bj.png'),
      require('./images/title.png'),
      require('./images/ailixisi_intro.png'),
      require('./images/intro.png'),
      require('./images/leina_intro.png')
    ]

    let LoadImgs = new Mztapi.LoadImg();

    this.$router.afterEach((to, from) => {
      count = to.meta.index;
      // console.log(to, from, 'after');
      // if (Object.keys(from.query).length){
      //   let {openid,sceneId} = from.query;
      //   to.query = { openid, sceneId}
      // }
    })

    this.$router.push({ path: '/elsword' });

    this.$router.beforeEach((to, from, next) => {
      $$('.app').setAttribute('id', to.name);
      Mztapi.removeClassName($$('#' + to.name), 'on');
      setTimeout(() => {
        Mztapi.addClassName($$('#' + to.name), 'on');
      }, 600);
      next();
    });
    _this.$nextTick(() => {
      // var Rect = $$('.list').getBoundingClientRect().top;
      // var Rect2 = $$('.comgz').getBoundingClientRect().top - 150;

      // var clientH = document.documentElement.clientHeight || document.body.clientHeight;

      LoadImgs.loadImages(sprt.imgs, 'fbs', async function() {
        $$('#loadingbg').style.display = 'none';
        setTimeout(() => {
          let a = window.location.href.split('#/')[1];
          $$('.app').setAttribute('id', a);
          Mztapi.addClassName($$('.app'), 'on');
        }, 300);
        requirejs(['share/share'], async(ztshare) => {
        // wx0fcf7f47419c8171 公共服务号

          let images = require('./images/share.png');

          var metaimage = document.createElement('meta');
          metaimage.setAttribute('content', '//' + window.location.host + images);
          metaimage.setAttribute('itemprop', 'image');
          document.querySelector('head').appendChild(metaimage);

          _this.minviteurl = 'https://' + window.location.host + '/act/heartel/';
          wximages = 'https://' + window.location.host + images;
          runWx = new ztshare({
            url: _this.minviteurl,
            title: wxtitle,
            desc: wxdesc,
            images: wximages,
            phone: {
              dataUrl: _this.minviteurl,
              success: function() {
              },
              cancel: function() {
              }
            }
          })

          // setTimeout(function() {
          //   Mztapi.loadScript('/js/copyright.js', () => {

          //   });
          // }, 200);
        })
      })

      //

      //
    })
  },
  methods: {
    mbconbtn(index) {
      count = index;
    },
    sccombtn(index) {
      count = index + 7;
    },
    go() {
      count += 1;

      if (count <= 13) {
        if (count < 7) {
          index = this.mbcom[count];
        } else {
          index = this.sccom[count - 7];
        }
      } else {
        count = 0;
        index = this.mbcom[count];
      }
      this.$router.push(index.url);

      this.transitionName = 'slide-right';
    },
    back() {
      count -= 1;

      if (count > -1) {
        if (count < 7) {
          index = this.mbcom[count];
        } else {
          index = this.sccom[count - 7];
        }
      } else {
        count = 13;
        index = this.sccom[count - 7];
      }

      this.$router.push(index.url);
      this.transitionName = 'slide-left';
    },
    scrollTop(t) {
      window.pageYOffset = document.documentElement.scrollTop = document.body.scrollTop = t;
    },
    msgclose(id) {
      event.stopPropagation(); // 阻止了事件冒泡，但不会阻击默认行为
      event.preventDefault(); // 阻止默认事件

      Mztapi.removeClassName($$('.cover'), 'on');
      Mztapi.removeClassName($$('#' + id), 'on');
    }
  }
};
</script>
<style scoped>

    .app {
        width: 100%;
    }
    /* 切页动画 */
    .router-view {
        position: absolute;
        top: 0;
        width: 100%;
        transition: all .5s ease;
    }

    .slide-left-enter,
    .slide-right-leave-active {
        -webkit-transform: translate(100%, 0);
        transform: translate(100%, 0);
    }

    .slide-left-leave-active,
    .slide-right-enter {
        -webkit-transform: translate(-100%, 0);
        transform: translate(-100% 0);
    }
</style>
